import React                                                                                   from 'react';
import { PluginDocumentSettingPanel }                                                          from '@wordpress/edit-post';
import { CheckboxControl }                                                                     from '@wordpress/components';
import withMetaboxValidation                                                                   from './withMetaboxValidation';
import { OrderBumpsMeta, ValidationRules }                                                     from '../../Types/ValidationRules';
import SelectWithLabel                                                                         from '../SelectWithLabel';
import ProductsAndVariationsCompleter                                                          from './ProductsAndVariationsCompleter';
import {__} from "@wordpress/i18n";

const getValidationRules: ( meta: OrderBumpsMeta ) => ValidationRules = ( meta ) => ( {
    cfw_ob_upsell_product: {
        required: () => meta.cfw_ob_upsell === 'yes',
        error: __('You must set an upsell replacement product.', 'checkout-wc' ),
    },
} );

const OrderBumpsGeneralPanel = ( { meta, handleFieldChange } ) => (
    <PluginDocumentSettingPanel
        name="cfw-ob-general"
        title={__( 'Offer Type', 'checkout-wc' ) }
        className="cfw-ob-general-mb"
    >
        <CheckboxControl
            label={__('Use Order Bump As Upsell', 'checkout-wc')}
            help={
                (
                    <>
                        {__('Replace a cart item with offer product when this Order Bump is taken.', 'checkout-wc')}
                    </>
                )
            }
            checked={ meta.cfw_ob_upsell === 'yes' }
            onChange={
                ( newValue: boolean ) => {
                    handleFieldChange( 'cfw_ob_upsell', newValue ? 'yes' : 'no' );
                }
            }
        />

        {meta.cfw_ob_upsell === 'yes' && <SelectWithLabel
            type="custom"
            label={__('Which product does this upsell replace in the cart?', 'checkout-wc')}
            autocompleter={ProductsAndVariationsCompleter}
            placeholder={__( 'Search for product', 'checkout-wc' )}
            multiple={false}
            selected={meta.cfw_ob_upsell_product}
            help={
                (
                    <>
                        {__('This product must be in the cart for this order bump to be shown.', 'checkout-wc')}
                    </>
                )
            }
            onChange={
                ( newValues: any ) => {
                    handleFieldChange( 'cfw_ob_upsell_product', newValues );
                }
            }
        />}
    </PluginDocumentSettingPanel>
);

export default withMetaboxValidation( OrderBumpsGeneralPanel, getValidationRules );
